import React from 'react'
import { Link } from "react-router-dom";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import Timer from '../Helpers/Timer';
import moment from "moment"

function Counter() {
  const targetDate = moment(new Date()).add(1, 'days').format("YYYY-MM-DD") + "T00:00:00";
  const {days, hours, minutes, seconds} = Timer(targetDate)
    useEffect(() => {
        AOS.init({disable: 'mobile',mirror:true});
        AOS.refresh();
      }, []);
  return (
    <>
    <div className='offerCounter' data-aos="zoom-in-up"
                      data-aos-delay="200" data-aos-easing="ease-in-sine">
        <h4>Only Available For 24 Hours.</h4>
        <h5>Don't Miss Out!</h5>
        <h6>Sale Ends in</h6>
        <div className="align-items-center d-flex justify-content-center">
        <span className='counter d-flex flex-column'><small>{hours}</small> Hours</span>
        <span className='timeDots'>:</span>
        <span className='counter d-flex flex-column'><small>{minutes}</small> Minutes</span>
        <span className='timeDots'>:</span>
        <span className='counter d-flex flex-column'><small>{seconds}</small> Seconds</span>
        </div>
        
        <Link to="/products" className="btn btn1 mt-4">
                            <div>
                              <div>View All Products</div>
                            </div>
                          </Link>
        
    </div>
    </>
    
  )
}

export default Counter